const types = {
  SET_ACCESSIBILITY : 'SET_ACCESSIBILITY'
}

export default types;
